import React from 'react';
import { motion } from 'framer-motion';
import { 
  ArrowRight, 
  Mail, 
  Linkedin, 
  Github,
  MessageSquare
} from 'lucide-react';

const Contact = () => {
  const socialLinks = [
    {
      icon: Linkedin,
      title: 'LinkedIn',
      value: 'linkedin.com/in/victorviccente',
      href: 'https://linkedin.com/in/victorviccente',
      color: 'hover:bg-blue-600/20 hover:border-blue-600/50 hover:text-blue-500'
    },
    {
      icon: Github,
      title: 'GitHub',
      value: 'github.com/victorviccente',
      href: 'https://github.com/victorviccente',
      color: 'hover:bg-blue-700/20 hover:border-blue-700/50 hover:text-blue-600'
    },
    {
      icon: Mail,
      title: 'Email',
      value: 'victorviccentecontato@gmail.com',
      href: 'mailto:victorviccentecontato@gmail.com',
      color: 'hover:bg-blue-500/20 hover:border-blue-500/50 hover:text-blue-400'
    },
  ];

  return (
    <section id="contact" className="relative py-32 overflow-hidden">
      <div className="absolute inset-0 bg-gradient-to-b from-black via-blue-900/20 to-black" />
      
      {/* Background Elements */}
      <div className="absolute inset-0 opacity-30">
        <div className="absolute top-1/4 left-1/4 w-64 h-64 bg-blue-500/20 rounded-full blur-3xl" />
        <div className="absolute bottom-1/4 right-1/4 w-64 h-64 bg-blue-700/20 rounded-full blur-3xl" />
      </div>

      <div className="container mx-auto px-4 relative z-10">
        <div className="max-w-4xl mx-auto">
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            className="text-center mb-16"
          >
            <motion.div 
              className="inline-flex items-center gap-2 bg-blue-500/10 px-4 py-2 rounded-full mb-4"
              whileHover={{ scale: 1.05 }}
            >
              <MessageSquare className="w-5 h-5 text-blue-400" />
              <span className="text-blue-400 font-medium">Vamos Conversar?</span>
            </motion.div>

            <h2 className="text-5xl font-bold mb-6 bg-clip-text text-transparent bg-gradient-to-r from-blue-400 to-blue-600">
              Vamos Trabalhar Juntos?
            </h2>
            <p className="text-xl text-blue-200 leading-relaxed max-w-2xl mx-auto">
              Estou sempre em busca de novos desafios e oportunidades empolgantes. 
              Se você tem um projeto inovador ou quer discutir ideias transformadoras, 
              ficarei feliz em conversar!
            </p>
          </motion.div>

          <div className="space-y-6">
            {/* Social Links */}
            {socialLinks.map((link, index) => (
              <motion.a
                key={link.title}
                href={link.href}
                
                rel="noopener noreferrer"
                initial={{ opacity: 0, y: 20 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ delay: index * 0.1 }}
                whileHover={{ scale: 1.02 }}
                className={`group flex items-center gap-6 p-6 bg-black/50 rounded-xl border border-blue-900/30 backdrop-blur-sm transition-all duration-300 ${link.color}`}
              >
                <div className="p-4 rounded-lg bg-blue-900/30 group-hover:scale-110 transition-transform duration-300">
                  <link.icon className="w-6 h-6 text-blue-400 group-hover:text-inherit transition-colors" />
                </div>
                <div>
                  <h3 className="font-semibold text-white group-hover:text-inherit transition-colors">
                    {link.title}
                  </h3>
                  <p className="text-blue-300 text-sm group-hover:text-inherit/80 transition-colors">
                    {link.value}
                  </p>
                </div>
                <ArrowRight className="w-5 h-5 text-blue-400 group-hover:translate-x-2 group-hover:text-inherit transition-all ml-auto" />
              </motion.a>
            ))}

            {/* Additional Info Card */}
            <motion.div
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ delay: 0.3 }}
              className="p-6 bg-gradient-to-r from-blue-500/10 to-blue-700/10 rounded-xl border border-blue-500/20 backdrop-blur-sm"
            >
              <h3 className="text-xl font-bold bg-clip-text text-transparent bg-gradient-to-r from-blue-400 to-blue-600 mb-4">
                Disponível para:
              </h3>
              <ul className="space-y-3">
                <li className="flex items-center gap-3 text-blue-200">
                  <div className="w-2 h-2 rounded-full bg-blue-500" />
                  Projetos Freelance
                </li>
                <li className="flex items-center gap-3 text-blue-200">
                  <div className="w-2 h-2 rounded-full bg-blue-500" />
                  Mentorias
                </li>
                <li className="flex items-center gap-3 text-blue-200">
                  <div className="w-2 h-2 rounded-full bg-blue-500" />
                  Parcerias
                </li>
              </ul>
            </motion.div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Contact;